import type { ConsentTypeKey } from './consentTypes';

/** Danish portal labels (the portal is not translated). */
export const PORTAL_CONSENT_TYPE_LABELS: Record<ConsentTypeKey, string> = {
  privacy_notice: 'Privatlivsinformation',
  portal_terms: 'Vilkår for patientportalen',
  marketing_email: 'Nyheder og tilbud på e-mail',
  marketing_sms: 'Nyheder og tilbud på SMS',
  photo_video: 'Billeder og video',
  other_purpose: 'Andet formål',
  sl_41_disclosure: 'Videregivelse af helbredsoplysninger til behandling',
  sl_43_disclosure: 'Videregivelse af helbredsoplysninger til andre formål',
  sl_42a_lookup: 'Opslag i helbredsoplysninger ved behandling',
  sl_42d_retrieval: 'Indhentning af helbredsoplysninger til andre formål',
  refusal_disclosure: 'Frabedelse af videregivelse',
  refusal_lookup: 'Frabedelse af opslag',
  journal_transfer: 'Overdragelse af journal',
  informed_treatment: 'Samtykke til behandling',
};

export interface PortalAnswerLabels {
  yes: string;
  /** null: the text is information only; it can be read, not refused. */
  no: string | null;
}

export function portalAnswerLabels(type: ConsentTypeKey): PortalAnswerLabels {
  switch (type) {
    case 'privacy_notice':
      return { yes: 'Jeg har læst informationen', no: null };
    case 'portal_terms':
      return { yes: 'Jeg accepterer vilkårene', no: 'Jeg accepterer ikke' };
    default:
      return { yes: 'Ja, jeg giver samtykke', no: 'Nej tak' };
  }
}

export interface PortalInboxItemLike {
  request_id: string;
  patient_id: string;
  patient_first_name: string;
  patient_last_name: string;
  relation_id: string | null;
  clinic_name: string;
  expires_at: string;
}

export interface PortalInboxGroup<T extends PortalInboxItemLike> {
  requestId: string;
  patientName: string;
  onBehalfOfOther: boolean;
  clinicName: string;
  expiresAt: string;
  items: T[];
}

/** Groups inbox rows per request, keeping the order the RPC returned. */
export function groupPortalInbox<T extends PortalInboxItemLike>(rows: readonly T[]): PortalInboxGroup<T>[] {
  const groups = new Map<string, PortalInboxGroup<T>>();
  for (const row of rows) {
    const key = `${row.request_id}:${row.relation_id ?? 'self'}`;
    let group = groups.get(key);
    if (!group) {
      group = {
        requestId: row.request_id,
        patientName: `${row.patient_first_name} ${row.patient_last_name}`.trim(),
        onBehalfOfOther: row.relation_id !== null,
        clinicName: row.clinic_name,
        expiresAt: row.expires_at,
        items: [],
      };
      groups.set(key, group);
    }
    group.items.push(row);
  }
  return [...groups.values()];
}

export const PORTAL_CONSENT_PROMPT_DISMISSED_KEY = 'clinio.portal.consentPromptDismissed';
